import React, { useContext } from 'react';
import { ChatContext } from './Context';
import styles from "./Chatbot.module.scss";
import genieLamp from "../../assets/images/genieLamp.svg";

const ChatToggleBox: React.FC = () => {
    const { setIsChatboxActive, scrollToBottom } = useContext(ChatContext);

    const toggleChatbox = () => {
        setIsChatboxActive((prev: any) => !prev);
        scrollToBottom();
    };

    return (
        <div className={styles.chatbox__button_genie}>
            <button onClick={toggleChatbox}>
                <img
                    src={genieLamp}
                    style={{ width: "40px", height: "40px" }}
                    alt="start"
                />
            </button>
        </div>
    );
};

export default ChatToggleBox;